<form name="form" #formRequestedDelay="ngForm" class="stewards-modal">
  <div class="modal-header stewards-modal-header">
    <h4 class="modal-title text-truncate">Requested Delay {{ race.raceDatetime | date:'h:mm a' }}</h4>
    <button type="button" class="stewards-modal-close" (click)="cancel('cancel')" aria-label="Close">
      <fa name="times"></fa>
    </button>
  </div>
  <div class="modal-body stewards-modal-body">
    <div *ngIf="meta.loading">
      <div class="row">
        <div class="col-12 text-center">
          <img src="assets/loader.svg" class="d-block ml-auto mr-auto" alt="spinner">
        </div>
      </div>
    </div>
    <div *ngIf="!meta.loading">
      <div class="row" *ngIf="requestedDelayRaces.inMinutes">
        <div class="col">
          <div class="late-race-list">
            <label class="stewards-modal-label d-inline">Advertised Time of Race</label>
            <p class="d-inline float-right">{{requestedDelayRaces.publishedRaceTime | racetime}}</p>
          </div>
          <div class="late-race-list">
            <label class="stewards-modal-label d-inline">New Race Time</label>
            <p class="d-inline float-right">{{requestedDelayRaces.requestedDelayTime | racetime}}</p>
          </div>
          <div class="late-race-list">
            <label class="stewards-modal-label d-inline">Minutes Difference</label>
            <p class="d-inline float-right">{{requestedDelayRaces.inMinutes}}</p>
          </div>
          <div class="late-race-list">
            <label class="stewards-modal-label d-inline">Further comments</label>
            <p class="d-inline float-right">{{requestedDelayRaces.action}}</p>
          </div>
        </div>
      </div>
      <div class="row" *ngIf="!requestedDelayRaces.inMinutes">
        <div class="col">
          <div class="form-group">
            <label class="stewards-modal-label d-inline mb-0">Original Race time: </label>
            <span>{{requestedDelayRaces.publishedRaceTime | racetime}}</span>
          </div>
          <div class="form-group" *ngIf="requestedDelayRaces.raceTime">
            <label class="stewards-modal-label d-inline mb-0">Requested Race time: </label>
            <span>{{requestedDelayRaces.raceTime}}</span>
          </div>
          <div class="form-group">
            <label class="stewards-modal-label">Delay in Minutes:</label>
            <input class="form-control" type="NUMBER" min="1" max="40" step="1" value="5" size="4" name="inMinutes" [(ngModel)]="inMinutes" (ngModelChange)="onTimeChange()">
          </div>
          <!-- ACTIONS -->
          <div class="form-group mb-0">
            <label class="stewards-modal-label">Further comments:</label>
            <textarea class="form-control" name="action" [(ngModel)]="action"></textarea>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="!meta.loading">
    <div *ngIf="!meta.saving" class="modal-footer stewards-modal-footer">
      <button type="button" class="btn btn-outline-secondary stewards-modal-btn-close" (click)="cancel('cancel')">Close</button>
      <button type="button" class="btn btn-primary" (click)="confirm()" [disabled]="formRequestedDelay.invalid" [hidden]="requestedDelayRaces.requestedDelayTime">Confirm</button>
      <button type="button" class="btn btn-danger" (click)="deleteRace()" *ngIf="requestedDelayRaces.requestedDelayTime">Delete</button>
    </div>
    <div *ngIf="meta.saving" class="modal-footer stewards-modal-footer stewards-modal-footer-loading">
      <fa name="circle-o-notch" animation="spin"></fa>
    </div>
  </div>
</form>
